const { API } = require("@Config/api");

export function getListJobSeeker(
  limit,
  page,
  placement,
  title,
  contractType,
  experience = [],
  minSalary,
  maxSalary,
  category = [],
  workSystem = [],
  workMethod = [],
  education = []
) {
  return new Promise(async (resolve, reject) => {
    try {
      const formData = new FormData();
      formData.append("limit", limit);
      formData.append("page", page);
      formData.append("placement", placement || "");
      formData.append("title", title || "");

      if (contractType?.length > 0) {
        contractType?.forEach((contractType) => {
          formData.append("contractType", contractType || "");
        });
      }

      if (experience?.length > 0) {
        experience?.forEach((experience) => {
          formData.append("experience", experience || "");
        });
      }

      formData.append("minSalary", minSalary || "");
      formData.append("maxSalary", maxSalary || "");
      formData.append(
        "candidateAccountID",
        localStorage.getItem("candidateID") || ""
      );

      if (category?.length > 0) {
        category?.forEach((c) => {
          formData.append("category", c || "");
        });
      }

      if (workSystem?.length > 0) {
        workSystem?.forEach((c) => {
          formData.append("workSystem", c || "");
        });
      }

      if (workMethod?.length > 0) {
        workMethod?.forEach((c) => {
          formData.append("workMethod", c || "");
        });
      }

      if (education?.length > 0) {
        education?.forEach((c) => {
          formData.append("education", c || "");
        });
      }

      const queryString = new URLSearchParams(formData).toString();

      const { data } = await API.get(`/job-post/landing?${queryString}`);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function getDetailJobPostForCandidate(id) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(
        `/landing-page/job-post/${id}?candidateAccountID=${
          localStorage.getItem("candidateID") || ""
        }`,
        {
          headers: {
            Authorization: localStorage.getItem("accessTokenUserLanding"),
          },
        }
      );

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}
